import React from "react";
import { useDispatch } from "react-redux";
import { hideModal } from "../../../actions/actionCreators";

import MaterialModal from "../MaterialModal";
import withModal from "../withModal";
import ImportBulkLogMain from "./import-bulk-log-main";

interface IImportBulkLogModal {
    isOpen: boolean;
}
const ImportBulkLogModal: React.FC<IImportBulkLogModal> = ({ isOpen }: IImportBulkLogModal) => {
    const dispatch = useDispatch();

    const hide = () => {
        dispatch(hideModal("IMPORT_BULK_LOG_MODAL"));
    };

    return (
        <div>
            <MaterialModal
                id="importbulk-log-modal"
                isOpen={isOpen}
                onClose={hide}
                title={""}
                showPrimaryButton={false}
                cancelButtonText="Close"
                fullWidth={true}
            >
                <ImportBulkLogMain
                //importedBulkFields={importedFields}
                //updateFields={setImportedFields}
                //onChangeImportAction={handleDelete}
                />
            </MaterialModal>
        </div>
    );
};
export default withModal(ImportBulkLogModal, "IMPORT_BULK_LOG_MODAL");
